// COMMON JS FOR EVERY PAGE HERE

$(document).ready(function () {

  // hack for iOS -webkit-tap-highlight-color
  document.addEventListener("touchstart", function () {}, true);

  $('.btn-primary').not('.btn-no-loading').on("click", function () {
    if (!$(this).hasClass('disabled')) {
      $(this).addClass('loading');
    }
  });

  // unveil on page load
  // delay the init of unveil. without the timeout it doesn't work correctly with async js file loading
  setTimeout(function () {
    _initUnveil();
  }, 30);

  $(document).bind('shopgateFramework.ui.contentUpdated', function (e, content) {

    if (typeof content !== 'undefined') {
      var unveilImages = content.find('.unveil');
    } else {
      var unveilImages = [];
    }

    _initUnveil(unveilImages.length ? unveilImages : null);
  });

  function _initUnveil(images) {
    var targetElements = null;

    if (images) {
      targetElements = images;
    } else {
      targetElements = $('.unveil');
    }

    targetElements.unveil(window.screen.height * 3, function () {
      // Check if image is already there (might be in browser cache, IE will not fire load event in this case)
      if ($(this).prop('complete')) {
        _showLoadedImage.call(this);
      } else {
        // Else wait for the load event to fade the image in
        $(this).load(_showLoadedImage);
      }
    });
  }

  /**
   * If the unveiled image has finished loading fade it in (and possibly show pagination from slider)
   *
   * @private
   */
  function _showLoadedImage() {
    if ($(this).data('unveil-pagination') == true) {
      var wrapper = $(this).closest('.swiper-wrapper');
      wrapper.next('.pagination').removeClass('hidden');
      wrapper.css('height', wrapper.closest('.sg-widget-image-slider').css('height')); // win phone hotfix
    }

    $(this).closest('.unveil-parent').css('opacity', 1);
  }

  // open&close functionality for user and category dropdown
  var modalOpen,
    merchantUserButton = $('#merchant-user-button'),
    merchantBar = $('#merchant-bar').collapse({
      toggle: false
    }),
    categoryToggle = $('#category-toggle'),
    accordionTop = $('#accordion-top').collapse({
      toggle: false
    }),
    navbarCollapseElements = accordionTop.add(merchantBar),
    backdrop = $('#backdrop'),
    navbarCollapseBusy = false;

  function toggleModal(modal, callback) {
    // prevents incorrect draw on show/hide when abusing a toggle button
    if (navbarCollapseBusy) {
      return false;
    }
    if (modalOpen && modal && modalOpen != modal) {
      toggleModal(modalOpen);
    }

    var show = false;
    if (!modalOpen && modal) {
      modalOpen = modal;
      show = true;
    }

    backdrop.toggle(show);

    switch (modalOpen) {
      case 'user':
        merchantUserButton.toggleClass('toggled', show);
        merchantBar.collapse(show ? 'show' : 'hide');
        break;
      case 'category':
        categoryToggle.toggleClass('toggled', show);
        accordionTop.collapse(show ? 'show' : 'hide');
        break;
    }

    if (!show)
      modalOpen = null;
  }

  /**
   * Prevents document to be scrolled beyond collapse menu.
   */
  function hijackScroll() {
    var elements = merchantBar.add(accordionTop);
    elements.on('shown.bs.collapse sizeChanged', function () {
      var $el = $(this),
        bodyHeight = parseInt($el.offset().top + $el.height()),
        windowHeight = parseInt($(window).height());
      if (bodyHeight < windowHeight) {
        bodyHeight = windowHeight;
      }
      $('body').height(bodyHeight);
      $('html').addClass('navbar-menu-opened');
    });

    elements.on('hide.bs.collapse', function () {
      $('body').css({
        'height': ''
      });
      $('html').removeClass('navbar-menu-opened');
    });
  }

  navbarCollapseElements.on('hide.bs.collapse show.bs.collapse', function () {
    navbarCollapseBusy = true;
  });

  navbarCollapseElements.on('hidden.bs.collapse shown.bs.collapse', function () {
    navbarCollapseBusy = false;
  });



  merchantUserButton.click(function (e) {
    e.preventDefault();
    toggleModal('user');
  });

  categoryToggle.click(function (e) {
    e.preventDefault();
    toggleModal('category');
  });

  hijackScroll();

  backdrop.add('#categorycloser').add('#userbarcloser').click(function (e) {
    e.preventDefault();
    toggleModal();
    $('html, body').animate({
      scrollTop: 0
    });
  });

  $('.cart-checkout-button:not(.sg-action)').click(function (e) {
    // Cross domain tracking for the SgTracking system
    if (window.SgTrackingCore.crossDomainTracking(this.href)) {
      e.preventDefault();
    }
  });

  // handle coupon popup closing stuff
  var couponDropdown = $('#coupon-dropdown'),
    closeBtn = $('.close-coupon-dropdown', couponDropdown),
    backdrop = $('#backdrop');
  closeBtn.add(backdrop).click(function (e) {
    e.preventDefault();
    $(this).removeClass('loading');
    couponDropdown.hide();
    backdrop.hide();
  });

  /**
   * AJAX LINKS
   *  make an ajax call for links with js-ajax-link class
   */
  $(document).on('click', 'a.js-ajax-link', function (e) {
    e.preventDefault();
    $.shopgate.ajax({
      url: this.href,
      beforeSend: function () {
        $.shopgate.spinner('show');
      }
    });
  });
});



// WEBPACK FOOTER //
// ./Library/1.0/phone/common.js